const import_latest_version_module = function (pParameter) {
    return import(`./1.1.2/index.vue`);
};

module.exports = import_latest_version_module;
